import { Controller } from "react-hook-form"
import RichTextInput from "../../../ui/RichTextInput"
import NumberInput from "../../../ui/NumberInput"
import { currencySymbol } from "~/utils/currencySymbol"
import useInvoiceSettings from "./useInvoicesSettings"
import SaveButtons from "../SaveButtons"
import ProcessingState from "~/components/ui/Admin/ProcessingState"

const InvoicesSettings = () => {
  const {
    reactHookForm,
    camp,
    onSubmit,
    isPendingSaveInvoices,
    handleSetDefaultValues,
    isLoadingData,
    isRateDisabled,
    loadedDone,
  } = useInvoiceSettings()

  if (isLoadingData) return <ProcessingState loadingMessages={[]} successMessage={""} />

  return (
    //TODO: I had to add an hack to make the richtext reactive, for some reason internally he is not
    // changing when the props change after initial mount, the component itself should be revised

    <form key={JSON.stringify(loadedDone)} onSubmit={reactHookForm.handleSubmit(onSubmit)}>
      <SaveButtons
        isDirty={reactHookForm.formState?.isDirty}
        errors={reactHookForm.formState?.errors}
        handleCancel={handleSetDefaultValues}
        isLoading={isPendingSaveInvoices}
      />
      <div className="flex flex-col gap-3">
        <Controller
          name="electricity_rate"
          control={reactHookForm.control}
          render={({ field }) => (
            <NumberInput
              label="Electric price"
              prefix={currencySymbol(camp?.currency) || "$"}
              suffix={camp?.currency.toUpperCase()}
              field="electricity_rate"
              disabled={isRateDisabled}
              resource={{ electricRate: field.value }}
              register={() => field}
            />
          )}
        />

        {camp?.electricity_rate == null && (
          <strong>Please contact support for customizing your electric prices.</strong>
        )}

        <div className="">
          <label className="block text-sm font-semibold leading-6 text-gray-900 mb-4">Default memo:</label>
          <Controller
            name="default_invoice_memo"
            control={reactHookForm.control}
            render={({ field }) => <RichTextInput value={field.value} setValue={field.onChange} />}
          />
        </div>
      </div>
    </form>
  )
}

export default InvoicesSettings
